export const appSettings = {
    methods: {
        getApiBaseUrl() {
            return process.env.VUE_APP_API_BASE_URL;
        }
    }
}